import React from 'react';
import PropTypes from 'prop-types';
import * as ErrorMessage from '../../../constants/common/ErrorMessage';

/**
 * ErrorComments
 */
class ErrorComments extends React.Component {

  componentDidMount() {
    Ts.loadFont(); console.log('Ts.loadFont');
  }

  render() {
    const errorCode = this.props.error.message;
    const errormessage = ErrorMessage.ERROR_MESSAGE.filter((item) => {
      return (item.code === errorCode);
    });

    let errClassName = 'error-ttl-box ';
    if (this.props.errorClassName != undefined) {
      errClassName += this.props.errorClassName;
    }

    const title = <h1 className="error-ttl">{errormessage[0].title}</h1>;
    const description = [];
    description.push(<p key="desc1">{errormessage[0].description_1}</p>);
    description.push(<p key="desc2">{errormessage[0].description_2}</p>);
    description.push(<p key="desc3">{errormessage[0].description_3}</p>);
    description.push(<p key="desc4">{errormessage[0].description_4}</p>);
    description.push(<p key="desc5">{errormessage[0].description_5}</p>);

    return (
      <div className="cf error_comments" >
        <div className={errClassName}>
          {title}
          {description}
        </div>
      </div>
    );
  }
}

ErrorComments.propTypes = {
  error: PropTypes.any.isRequired,
  errorClassName: PropTypes.any.isRequired
};

export default ErrorComments;
